import { render } from "./delete.vue?vue&type=template&id=25c83952&scoped=true"
import script from "./delete.vue?vue&type=script&lang=js"
export * from "./delete.vue?vue&type=script&lang=js"

import "./delete.vue?vue&type=style&index=0&id=25c83952&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c83952"]])

export default __exports__